import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import _ from 'lodash';
import { auth } from '../../../../../services/auth.service';

class RegionForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            districts: [],
			regionInEdit: this.props.dataItem || null,
			value: [],            
            originalRegionName: this.props.dataItem.description || '',
            originalRangerEmail: this.props.dataItem.assignedLoginId || '',
            originalDistricts: this.props.dataItem.districtLst || [],
            emailMessage: Object.keys(this.props.dataItem).length == 0 ? '' : this.props.dataItem.firstName + " " + this.props.dataItem.lastName,
            regionMessage: '',
            districtMessage: Object.keys(this.props.dataItem).length == 0 ? "At least one district must be selected" : ""
		};
		this.delayedCallback = _.debounce(this.checkEmailCall, 500);
        this.onEmailChange = this.onEmailChange.bind(this);
	}

    componentDidMount() {
        if (!this.state.regionInEdit.regionId) {//If its on new
            axios
                .get(`${ROOT_API_URL}/ManageRegions/GetAvaliableDistricts?`, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        districts: response.data.sort((a, b) => (a.districtName > b.districtName) ? 1 : ((b.districtName > a.districtName) ? -1 : 0))
                    })
                })
                .catch((response) => {
                    console.log(response);
                });
        }
        else {//If its on edit
            let model = { regionId: this.state.regionInEdit.regionId }

            axios
                .post(`${ROOT_API_URL}/ManageRegions/GetAvaliableDistrictsOnEdit`, model, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        districts: response.data.sort((a, b) => (a.districtName > b.districtName) ? 1 : ((b.districtName > a.districtName) ? -1 : 0))
                    })
                })
                .catch((response) => {
                    console.log(response);
                });
        }
    }
    checkEmailCall() {
        axios
            // .get(`${ROOT_API_URL}/ManageDistrict/CheckAdminUserByEmail?email=${this.state.regionInEdit.assignedLoginId}`, { headers: auth.authHeader() })
            .post(`${ROOT_API_URL}/ManageDistrict/CheckAdminUserByEmail`,
                {
                    email: this.state.regionInEdit.assignedLoginId
                },
                {
                    headers: auth.authHeader()
                }
            )
            .then((response) => {
                this.setState({
                    emailMessage: response.data.message
                })
        })
        .catch((response) => {
            console.log(response);
        });
    }

	onEmailChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.regionInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState(
			{
				regionInEdit: edited,
				emailMessage: ''
			},
			() => {
				this.delayedCallback();
			}
		);
	};

	handleSubmit = (event) => {
        event.preventDefault();

        axios
            .post(`${ROOT_API_URL}/ManageRegions/IsRegionAlreadyExist`, this.state.regionInEdit, { headers: auth.authHeader() })
            .then((response1) => {
                axios
                    .post(`${ROOT_API_URL}/ManageRegions/IsRangerAlreadyHasARegion`, this.state.regionInEdit, { headers: auth.authHeader() })
                    .then((response2) => {
                        let url = `${ROOT_API_URL}/ManageRegions/AreDistrictsAvailable`;
                        if (this.state.regionInEdit.regionId) {
                            url = `${ROOT_API_URL}/ManageRegions/AreDistrictsAvailableOnEdit`;
                        }

                        axios
                            .post(url, this.state.regionInEdit, { headers: auth.authHeader() })
                            .then((response3) => {
                                if (this.state.originalRegionName != this.state.regionInEdit.description) {
                                    this.setState({
                                        regionMessage: response1.data.message
                                    });
                                }
                                if (this.state.originalRangerEmail != this.state.regionInEdit.assignedLoginId) {
                                    let msg = response2.data.message == "" ? this.state.emailMessage : response2.data.message
                                    this.setState({
                                        emailMessage: msg
                                    });
                                }
                                this.setState({
                                    districtMessage: response3.data.message
                                });
                                //If form is valid
                                if (this.state.districtMessage == ""
                                    && (this.state.emailMessage != "" && this.state.emailMessage != "User does not exist. Please create the user.")
                                    && this.state.regionMessage == "") {

                                    this.props.save(this.state.regionInEdit);
                                    this.props.cancel();
                                }
                            })
                            .catch((response3) => {
                                console.log(response3);
                            });
                    })
                    .catch((response2) => {
                        console.log(response2);
                    });
            })
            .catch((response1) => {
                console.log(response1);
            });
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.regionInEdit;
		edited[name] = value;
		//edited.isActive = true;
		this.setState({
            regionInEdit: edited,
            regionMessage: ''
		});
	};

    handleDistrictSelect = (event) => {
		console.log(event.target.value);
		var currentState = { ...this.state.regionInEdit };
        currentState.districtLst = [...event.target.value.sort((a, b) => (a.districtName > b.districtName) ? 1 : ((b.districtName > a.districtName) ? -1 : 0))];


		this.setState({
            regionInEdit: currentState,
            districtMessage: event.target.value.length == 0 ? 'At least one district must be selected':''
		});
	};

	render() {
		return (
			<Dialog onClose={this.props.cancel}>
                {!this.state.regionInEdit.regionId ?
                    <h2 className="adjust-dist-title">Add New Region</h2> :
                    <h2 className="adjust-dist-title">Edit Region</h2>
                }
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="description">Region Name</label>
						<Input
							required={true}
							type="text"
							name="description"
							id="description"
							value={this.state.regionInEdit.description || ''}
							onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.regionMessage}</p>
					</div>

					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="assignedLoginId">Ranger Email</label>
						<Input
							required={true}
							type="email"
							name="assignedLoginId"
							id="assignedLoginId"
							value={this.state.regionInEdit.assignedLoginId || ''}
							onChange={this.onEmailChange}
						/>
						<p className="error-message">{this.state.emailMessage}</p>
					</div>

					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="districts">Districts</label>
						<MultiSelect
							data={this.state.districts}
							onChange={this.handleDistrictSelect}
							value={this.state.regionInEdit.districtLst}
							textField="districtName"
							dataItemKey="districtId"
							allowCustom={true}
							name="districts"
							id="districts"
                        />
                        <p className="error-message">{this.state.districtMessage}</p>
					</div>
					<DialogActionsBar>
                        <div className="adjust-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{!this.state.regionInEdit.regionId ? (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-save"></i>
										<span>SAVE</span>
									</button>
								) : (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-edit"></i>
										<span>UPDATE</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</Dialog>
		);
	}
}

export default RegionForm;
